import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const DEFAULT = {
  branding: { company_name: "Digi Hub Solution", short_name: "Digi Hub", tagline: "Let's Go Digital" },
  contact: { phone1: "", phone2: "", email: "", address: "", hours: [] },
  socials: { facebook: "#", instagram: "#", linkedin: "#" },
  whatsapp: { number: "919808724448", message: "Hi, I'm interested in your services." },
  hero: { eyebrow: "WE SERVE IN", cta_primary: "Contact Us", cta_secondary: "Explore Services", stats: [] },
  about: { eyebrow: "", heading: "", highlight: "", paragraph1: "", paragraph2: "" },
  testimonials: [],
};

const SiteContext = createContext(DEFAULT);

export function SiteProvider({ children }) {
  const [site, setSite] = useState(DEFAULT);
  const [cities, setCities] = useState([]);

  const loadCities = useCallback(() => {
    api.get("/cities").then(({ data }) => setCities(data)).catch(() => setCities([]));
  }, []);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/site");
      setSite({ ...DEFAULT, ...data });
    } catch (err) {
      // Preserve DEFAULT content on network/CORS failure; log for debugging
      console.warn("[site] Failed to load /api/site — using defaults:", err?.response?.status || err?.message);
    }
  }, []);

  useEffect(() => { load(); loadCities(); }, [load, loadCities]);

  return (
    <SiteContext.Provider value={{ site, reloadSite: load, cities, reloadCities: loadCities }}>
      {children}
    </SiteContext.Provider>
  );
}

export function useSite() {
  return useContext(SiteContext);
}
